Pixlee.module('Tap2ShopApp.Show', function(Show, App, Backbone, Marionette, $) {
    Show.Controller = App.Controllers.Application.extend({
        initialize: function(options) {
            var collectionView;
            var photoscollection = App.request('get:photos:widget:photowall');
            var layout = this.getLayout({
                collection: photoscollection
            });
            var _this = this;
            this.listenTo(layout, 'show', function() {
                collectionView = this.getCollectionView({
                    collection: photoscollection
                });
                photoscollection.on('sync', function(collection, resp) {
                    if (_this.widgetloaded) {
                        return false;
                    }
                    _this.widgetloaded = true;
                    gon.sortType = resp.sortType;
                    App.commands.execute('opened:tap2shop', collection.pluck('album_photo_id'));
                });
                this.show(collectionView, {
                    region: layout.frame
                });
            });
            if (!_.isFalsy(gon.previewMode)) {
                var _this = this;
                var widget_numberOfPhotos = "30";
                var header_sponserImage_input;

                App.commands.setHandler('stylesheet:generated', function(css, params, display_options) {
                    widget_numberOfPhotos = widget_numberOfPhotos || display_options.pageSize;
                    header_sponserImage_input = header_sponserImage_input || params.header_sponserImage_input;
                    if (!_.isFalsy(params.header_sponserImage_input)) {
                        header_sponserImage_input = params.header_sponserImage_input;
                        App.displayOptions.set('header_sponserImage_input', header_sponserImage_input);
                    }
                    collectionView.triggerMethod('stylesheet:generated');
                });
            }

            this.show(layout, {
                loading: true
            });

        },
        getLayout: function(options) {
            return new Show.Layout(options);
        },
        getCollectionView: function(options) {
            return new Show.PhotowallCollection(options);
        }
    });

});